import {StyleSheet, Platform} from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createDropdownStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      position: Typography.position.relative,
      zIndex: 100,
    },
    innerContainer: {
      gap: Typography.gap.gap8,
    },
    input: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.workOrderSortIconsBorder,
      borderRadius: Typography.radius.radius8,
      paddingHorizontal: Typography.padding.padding12,
      //paddingVertical: Typography.padding.padding8,
      backgroundColor: theme.mainBg,
      height: Typography.height.dropDownheight,
      maxHeight: Typography.height.dropDownheight,
      gap: Typography.gap.gap8,
    },
    /** Trigger — open and panel is BELOW: zero the bottom corners */
    dropdownOpen: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    /** Trigger — open and panel is ABOVE: zero the top corners */
    dropdownOpenAbove: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    /** Panel — showing BELOW trigger: zero the top corners (flush with trigger) */
    panelOpenBelow: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    /** Panel — showing ABOVE trigger: zero the bottom corners (flush with trigger) */
    panelOpenAbove: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    disabledInput: {
      borderColor: theme.workOrderDisabledSortIconsBorder,
      backgroundColor: theme.disabledBG,
    },
    openInput: {
      borderColor: theme.openBorderColor,
    },
    hoverInput: {
      backgroundColor: theme.hoverBGColor,
    },
    label: {
      color: theme.dropdownTitleColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.semiBold,
    },
    inputText: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      color: theme.workOrderSortSelected,
      fontFamily: Typography.fontFamily.inter,
    },
    placeHodlerInputText: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      color: theme.workOrderDropdownPlaceholderText,
      fontFamily: Typography.fontFamily.inter,
    },
    showLabelWithSelected: {
      flexDirection: 'row',
      height: Typography.height.dropDownheight,
      maxHeight: Typography.height.dropDownheight,
      alignItems: Typography.textAlign.centerAlign,
    },
    showlabelText: {
      color: theme.sortByText,
    },
    modalOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    dropdownMenu: {
      position: 'absolute',
      backgroundColor: theme.dropdownBGColor,
      borderRadius: Typography.radius.radius8,
      borderColor: theme.openBorderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      shadowColor: theme.dropdownShadowColor,
      shadowOffset: {width: 0, height: Typography.height.height4},
      shadowOpacity: 1,
      shadowRadius: 8,
      elevation: 8,
      // Clip children to the panel's border radius so the last visible item
      // always respects the rounded bottom corners regardless of scroll position.
      // On Android, overflow:'hidden' removes elevation shadow, so skip it there.
      overflow: Platform.OS === 'android' ? ('visible' as const) : ('hidden' as const),
    },
    dropdownWithSearchMenu: {
      position: 'absolute',
      backgroundColor: theme.dropdownBGColor,
      borderRadius: Typography.radius.radius8,
      borderColor: theme.openBorderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      shadowColor: theme.dropdownShadowColor,
      shadowOffset: {width: 0, height: Typography.height.height4},
      shadowOpacity: 1,
      shadowRadius: 8,
      elevation: 8,
      overflow: Platform.OS === 'android' ? ('visible' as const) : ('hidden' as const),
    },
    dropdownValues: {
      //paddingTop: Typography.padding.padding10,
      //paddingBottom: Typography.padding.padding16,
      gap: Typography.gap.gap16,
    },
    dropdownSearchValues: {
      borderBottomRightRadius: Typography.radius.radius6,
      borderBottomLeftRadius: Typography.radius.radius6,
    },
    menuItem: {
      paddingHorizontal: Typography.padding.padding10,
      paddingVertical: Typography.padding.padding13,
      justifyContent: Typography.contentAlign.spaceBetween,
      flexDirection: 'row',
    },
    menuItemText: {
      color: theme.dropdownTextColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize13,
      fontWeight: Typography.fontWeight.regular,
    },
    descText: {
      color: theme.dropdownTextColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.regular,
    },
    arrowIcon: {
      color: theme.workOrderIcon,
    },
    activeItem: {
      backgroundColor: theme.selectedDropdownBGColor,
    },
    menuItemHover: {
      backgroundColor: theme.menuItemHoverBGColor,
    },
    activeItemText: {
      color: theme.selectedDropdownTextColor,
      fontWeight: Typography.fontWeight.regular,
    },
    dropdownItemContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap5,
    },
    mandatoryMark: {
      color: theme.formMandatory,
    },
    // ── Search-enabled dropdown styles ──────────────────────────────────────
    searchRow: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      // Use a full 1px bottom border as the separator between the search row
      // and the list — borderWidth0125 (≈0.125px) rounds to 0 on Android/iOS.
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      borderBottomColor: theme.searchBorder,
      backgroundColor: theme.dropdownBGColor,
      height: Typography.height.dropDownheight,
      overflow: 'hidden',
      gap: Typography.gap.gap8,
      // Match the container's top border radius so the search row fills the
      // rounded corners correctly. Adding overflow:'hidden' to the parent
      // would kill elevation/shadow on Android, so we mirror the radius here.
      borderTopLeftRadius: Typography.radius.radius8,
      borderTopRightRadius: Typography.radius.radius8,
    },
    searchIconWrapper: {
      paddingLeft: Typography.padding.padding18,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      alignSelf: 'stretch' as const,
    },
    searchTextInput: {
      flex: 1,
      fontSize: Typography.fontSize.fontSize14,
      color: theme.dropdownTextColor,
      fontFamily: Typography.fontFamily.inter,
    },
    closeIcon: {
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
       width: Typography.width.width40,
    },
    searchArrowBtn: {
      height: Typography.height.dropDownheight,
      backgroundColor: theme.searchResultBGColor,
      borderLeftColor: theme.searchBorder,
      borderRightColor: 'transparent',
      borderWidth: Typography.borderWidth.borderWidth1,
      borderTopWidth: 0,
      borderBottomWidth: 0,
      width: Typography.width.width40,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      padding: 0,
      margin: 0,
    },
    itemSeparator: {
      height: Typography.borderWidth.borderWidth1,
      backgroundColor: theme.workOrderSortIconsBorder,
      marginHorizontal: Typography.padding.padding10,
    },
    boldMenuItemText: {
      color: theme.dropdownTextColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.semiBold,
    },
    emptyMessageContainer: {
      paddingHorizontal: Typography.padding.padding10,
      paddingVertical: Typography.padding.padding13,
    },
    emptyMessageSearchContainer: {
      paddingHorizontal: Typography.padding.padding10,
      paddingVertical: Typography.padding.padding13,
      borderBottomRightRadius: Typography.radius.radius6,
      borderBottomLeftRadius: Typography.radius.radius6,
    },
    emptyMessageText: {
      color: theme.dropdownTextColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
    },
    tickMark: {
      alignSelf: Typography.textAlign.centerAlign,
    },
    /** Applied to the last VISIBLE item (panel opens below) so its bottom corners
     *  match the panel's borderRadius. */
    menuItemLast: {
      borderBottomLeftRadius: Typography.radius.radius8,
      borderBottomRightRadius: Typography.radius.radius8,
    },
    /** Applied to the first VISIBLE item (panel opens above) so its top corners
     *  match the panel's borderRadius. */
    menuItemFirst: {
      borderTopLeftRadius: Typography.radius.radius8,
      borderTopRightRadius: Typography.radius.radius8,
    },
  });
